import axios from "axios";

export const loader = document.getElementById("loader");
export const loadNow = (opacity) => {
  if (opacity <= 0) {
    displayContent();
  } else {
    loader.style.opacity = opacity;
    window.setTimeout(function () {
      loadNow(opacity - 0.05);
    }, 50);
  }
};
const displayContent = () => {
  loader.style.display = "none";
};
export default async function ApiRequest(url, method, body, header) {
  const baseurl = "https://happiemarketing.com/mobile_app_api/";
  let obj = {
    method: method,
  };
  if (body) {
    obj["body"] = body;
  }
  if (header) {
    if (!header["Content-Type"]) header["Content-Type"] = "application/json";
    obj["headers"] = header;
  } else {
    obj["headers"] = { "Content-Type": "application/json" };
  }
  try {
    obj.url = baseurl + url;
    let ApiRequest = null;
    loader.style.opacity = 1;
    loader.style.display = "flex";
    if (method.toLowerCase() === "GET")
      ApiRequest = await axios.get(baseurl + url, { headers: obj.headers });
    else
      ApiRequest = await axios.post(baseurl + url, obj.body, {
        headers: obj.headers,
      });
    let res = null;
    if (ApiRequest.status === 200) {
      res = ApiRequest.data;
    } else {
      res = {
        status: "error",
        statusCode: ApiRequest.status,
        message: ApiRequest.statusText,
      };
    }
    console.log(res);
    loadNow(1);
    return res;
  } catch (e) {
    console.log(e);
    loadNow(1);
    return { status: "error", message: e.message };
  }
}
